module.exports = __webpack_public_path__ + "static/media/buddy_referral_congratulation.ae37cb37.svg";